// src/utils/practiceStatsSummary.js
//
// Biletele practicii și rezumatul statisticii lor (GET /exams/practice/stats),
// folosite de fereastra de statistică și de pagina principală a elevului.

// proiectul e pe CRA: doar variabilele REACT_APP_* ajung în build
const readEnv = (key) =>
   (typeof process !== "undefined" && process?.env && process.env[key]) || "";

const START_ID = Number(readEnv("REACT_APP_TICKETS_START") || 246);
const COUNT = Number(readEnv("REACT_APP_TICKETS_COUNT") || 269 - 246 + 1);

/** Aceleași bilete ca în lista de practică. */
export const PRACTICE_TICKET_IDS = Array.from(
   { length: COUNT },
   (_, i) => START_ID + i,
);

/** Numărul biletului, cum apare în lista de practică (Biletul 1, 2, …). */
export function ticketNumber(ticketId) {
   return Number(ticketId) - START_ID + 1;
}

/** Se emite la ieșirea dintr-un bilet / o temă: statistica se reîncarcă. */
export const PRACTICE_ATTEMPT_FINISHED_EVENT = "practice:attempt-finished";

/** Biletele / temele după stare: trecute, cu greșeli, în lucru, neîncepute. */
export function groupByState(rows) {
   const out = { total: 0, passed: 0, errors: 0, started: 0, untouched: 0 };
   for (const row of rows || []) {
      out.total += 1;
      if (row.passed) out.passed += 1;
      else if (Number(row.red) > 0) out.errors += 1;
      else if (Number(row.green) > 0) out.started += 1;
      else out.untouched += 1;
   }
   return out;
}

/**
 * Toate răspunsurile date, și cele repetate la aceeași întrebare
 * (8 răspunsuri la o întrebare = 8). `percent` e null fără răspunsuri.
 */
export function answersAccuracy(summary) {
   const correct = Math.max(0, Number(summary?.answersCorrect) || 0);
   const wrong = Math.max(0, Number(summary?.answersWrong) || 0);
   const answered = correct + wrong;
   return {
      correct,
      wrong,
      answered,
      percent: answered > 0 ? Math.round((100 * correct) / answered) : null,
   };
}
